<template>
  <div style="height: 100%;">
    <!-- 文档：https://www.tiny.cloud/docs/tinymce/6/ -->
    <Editor :value="content" :init="initSetting" ref="tinymce" />

    <!-- 上传图片框 -->
    <a-modal
      v-model="showUploadImage"
      :title="$t(uploadType === 'video' ? 'com_btn_upload_video' : 'com_btn_upload_image')"
      @cancel="() => (showUploadImage = false)"
      centered
      :width="540"
      :maskClosable="false"
      destroyOnClose
    >
      <a-form-model :model="formUploadImage" :rules="formUploadImageRules" ref="uploadImageForm">
        <a-form-model-item :label="null" prop="images">
          <UploadOSS
            :value="formUploadImage.images"
            :manuallyUpload="true"
            @change="
              fileList => {
                formUploadImage.images = fileList || [];
                insertImageLoading = false;
              }
            "
            @selected="uploadSelected"
            :maxCount="5"
            uploadDirInOSS="document"
            :uploadType="uploadType"
            :initValue="pasteImage"
            ref="uploadElement"
            multiple
          />
        </a-form-model-item>
      </a-form-model>

      <template slot="footer">
        <a-button type="primary" size="large" @click="handleUpload" :loading="insertImageLoading">
          {{ $t(uploadType === 'video' ? 'com_btn_insert_video' : 'com_btn_insert_image') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue';
import { generateSignedUrl } from '@/config/oss';

export default {
  components: {
    Editor,
  },
  props: ['value', 'height'],
  watch: {
    value(value) {
      this.content = value;
    },
  },
  created() {
    this.content = this.value;
  },
  data() {
    return {
      // 上传类型
      uploadType: 'image',
      pasteImage: [],

      // 自定义上传图片
      showUploadImage: false,
      formUploadImage: {
        images: undefined,
        selected: undefined,
      },
      formUploadImageRules: {
        images: [
          {
            required: true,
            message: this.$t('com_form_upload_image_error'),
            trigger: 'change',
            validator: (rule, value, callback) => {
              if (
                !(
                  (this.formUploadImage?.images || []).length ||
                  (this.formUploadImage?.selected || []).length
                )
              ) {
                callback(this.$t('com_form_upload_image_error'));
                return false;
              }
              callback();
            },
          },
        ],
      },
      insertImageLoading: false,

      content: '',
      initSetting: {
        // auto_focus: true,
        toolbar_mode: 'wrap',
        // plugins:
        // preview 预览
        // importcss 导入css
        // searchreplace 搜索替换
        // autolink 自动加上链接，如www.example.com is converted to http://www.example.com
        // autosave 自动保存
        // save 保存
        // directionality 文字方向
        // code 代码条插入
        // visualblocks 用于显示视觉块，如<p><div>标签等，会虚线显示
        // visualchars 用于显示空格是否可见，勾选后，空格可见
        // fullscreen 全屏
        // image 上传图片
        // link 插入链接
        // template 插入模板
        // codesample 插入代码块
        // table 插入表格
        // charmap 特殊字符
        // pagebreak 分隔符
        // nonbreaking 插入空格
        // anchor 插入锚点
        // insertdatetime 插入时间
        // advlist 广告列表
        // lists
        // wordcount 文字数量统计
        // help 帮助
        // quickbars
        // emoticons 图标
        plugins:
          'preview searchreplace autolink autosave save code visualblocks visualchars fullscreen link codesample table charmap pagebreak image nonbreaking anchor insertdatetime wordcount help emoticons quickbars',
        toolbar:
          'undo redo | bold italic underline strikethrough  forecolor backcolor  table customInsertImage customInsertVideo link  | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullistremoveformat pagebreak charmap  insertfile  codesample  | fullscreen  preview ',
        // 下拉字体大小：https://www.tiny.cloud/docs/tinymce/6/user-formatting-options/#font_size_formats
        font_size_formats: '8px 10px 12px 14px 18px 24px 36px',
        // 菜单栏
        menubar: false,
        // 底部状态栏
        statusbar: false,
        // enter换行，quickbars
        quickbars_insert_toolbar: false,
        automatic_uploads: true,
        a11y_advanced_options: false,
        autosave_ask_before_unload: true,
        autosave_interval: '30s',
        autosave_restore_when_empty: false,
        autosave_retention: '2m',
        importcss_append: true,
        height: this.height || 300,
        image_caption: true,
        quickbars_selection_toolbar:
          'forecolor backcolor bold italic | h2 h3 blockquote | link quickimage quicktable',
        noneditable_class: 'mceNonEditable',
        contextmenu: 'link image table',
        // 主题皮肤: 自定义皮肤https://skin.tiny.cloud/t5/?_ga=2.82538387.442912900.1664417608-563844731.1664417608
        // 弄好后下载到本地/public/tinymce/skins目录，重命名自定义的皮肤，下面skin填上自定义的名称
        skin: 'infypower',
        content_css: 'default',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        setup: editor => {
          // 内容改变
          editor.on('change', _e => {
            this.content = editor.getContent();
            this.$emit('change', this.content);
          });

          // 粘贴上传
          editor.on('paste', event => {
            if (event.clipboardData || window.clipboardData) {
              const clipboardData = event.clipboardData || window.clipboardData;

              if (clipboardData.items) {
                for (let i = 0; i < clipboardData.items.length; i++) {
                  const item = clipboardData.items[i];

                  // 检查是否是图片
                  if (item.type.startsWith('image/')) {
                    const blob = item.getAsFile();
                    if (!blob) continue;

                    const timestamp = Date.now();
                    const uniqueId = `${timestamp}_${Math.random()
                      .toString(36)
                      .substring(2, 8)}`;
                    const fileName = `paste_png_${uniqueId}.png`;

                    const file = new File([blob], fileName, { type: blob.type });

                    if (file) {
                      const objectUrl = URL.createObjectURL(file);
                      const newFile = {
                        uid: uniqueId,
                        name: fileName,
                        url: objectUrl,
                        type: blob.type,
                        // 用于提交OSS上传用的对象
                        originFileObj: new File([blob], fileName, { type: blob.type }),
                      };

                      this.uploadType = 'image';
                      this.showUploadImage = true;
                      this.$nextTick(() => {
                        this.$refs.uploadElement.onChange([newFile], 'pasted');
                      });
                    }

                    // 阻止默认行为（可选）
                    event.preventDefault();
                  }
                }
              }
            }
          });

          editor.on('init', async function() {
            // // 确保光标定位在内容的最后
            // var content = editor.getContent();
            // editor.setContent(content); // 重设内容（可能触发光标跳到最后）
            // editor.selection.select(editor.getBody(), true); // 选择整个body
            // editor.selection.collapse(false); // 将光标放到内容的最后
          });

          // Tinymce的图标库
          // https://www.tiny.cloud/docs/tinymce/latest/editor-icon-identifiers/

          // 上传图片按钮
          editor.ui.registry.addButton('customInsertImage', {
            icon: 'image', // 使用 TinyMCE 内置的 "image" 图标
            tooltip: this.$t('com_btn_insert_image'), // 鼠标悬停时显示的提示
            onAction: () => {
              this.uploadType = 'image';
              this.showUploadImage = true;
            },
          });

          // 上传视频按钮
          editor.ui.registry.addButton('customInsertVideo', {
            icon: 'embed', // 使用 TinyMCE 内置的 "image" 图标
            tooltip: this.$t('com_btn_insert_video'), // 鼠标悬停时显示的提示
            onAction: () => {
              this.uploadType = 'video';
              this.showUploadImage = true;
            },
          });
        },

        file_picker_types: 'image',
        /* and here's our custom image picker*/
        file_picker_callback: (cb, _value, _meta) => {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');

          input.addEventListener('change', e => {
            const file = e.target.files[0];

            const reader = new FileReader();
            reader.addEventListener('load', () => {
              /*
                Note: Now we need to register the blob in TinyMCEs image blob
                registry. In the next release this part hopefully won't be
                necessary, as we are looking to handle it internally.
              */
              const id = 'blobid' + new Date().getTime();
              // eslint-disable-next-line no-undef
              const blobCache = tinymce.activeEditor.editorUpload.blobCache;
              const base64 = reader.result.split(',')[1];
              const blobInfo = blobCache.create(id, file, base64);
              blobCache.add(blobInfo);

              /* call the callback and populate the Title field with the file name */
              cb(blobInfo.blobUri(), { title: file.name });
            });
            reader.readAsDataURL(file);
          });

          input.click();
        },
      },
    };
  },
  methods: {
    //base64转blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    setContent(content) {
      this.content = content;
      const editor = this.$refs.tinymce.editor;
      editor.setContent('');
    },

    // 上传图片
    handleUpload() {
      this.$refs.uploadImageForm.validate(async valid => {
        if (valid) {
          this.insertImageLoading = true;
          this.$refs.uploadElement.handleUpload(() => {
            if (this.uploadType === 'video') {
              this.insertVideo();
            } else {
              this.insertImage();
            }
          });
        }
      });
    },

    uploadSelected(fileList) {
      this.formUploadImage.selected = fileList || [];
    },

    // 插入图片
    insertImage() {
      this.$refs.uploadImageForm.validate(async valid => {
        if (valid) {
          this.insertImageLoading = true;
          // 插入内容到编辑器
          const editor = this.$refs.tinymce.editor;
          const _images = this.formUploadImage?.images || [];
          const images = [];
          Promise.all(
            _images.map(async file => {
              const fullUrl = await generateSignedUrl({ objectKey: file });
              images.push(fullUrl);
            })
          ).then(() => {
            images.forEach(url => {
              editor.execCommand(
                'mceInsertContent',
                false,
                `<img src="${url}" data-src="image" />`
              );
            });

            this.$refs.uploadImageForm.resetFields();
            this.$refs.uploadElement.reset();

            this.showUploadImage = false;
            this.insertImageLoading = false;
          });
        }
      });
    },

    // 插入视频
    insertVideo() {
      this.$refs.uploadImageForm.validate(async valid => {
        if (valid) {
          this.insertImageLoading = true;
          // 插入内容到编辑器
          const editor = this.$refs.tinymce.editor;
          const _images = this.formUploadImage?.images || [];
          const images = [];
          Promise.all(
            _images.map(async file => {
              const fullUrl = await generateSignedUrl({ objectKey: file });
              images.push(fullUrl);
            })
          ).then(() => {
            images.forEach(url => {
              editor.execCommand(
                'mceInsertContent',
                false,
                `<video controls width="640" height="360" data-src="video"><source src="${url}" type="video/mp4" ><source src="${url}" type="video/3gpp" >${this.$t(
                  'com_video_not_support'
                )}
                </video>`
              );
            });

            this.$refs.uploadImageForm.resetFields();
            this.$refs.uploadElement.reset();

            this.showUploadImage = false;
            this.insertImageLoading = false;
          });
        }
      });
    },
  },
};
</script>
